import { render, staticRenderFns } from "./LayananPengaduan.vue?vue&type=template&id=de401a0a&scoped=true&"
import script from "./LayananPengaduan.vue?vue&type=script&lang=js&"
export * from "./LayananPengaduan.vue?vue&type=script&lang=js&"
import style0 from "./LayananPengaduan.vue?vue&type=style&index=0&id=de401a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de401a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
